import styled from "styled-components";

// THEME
import { Layout } from "antd";

// CONST
import { DIMENSIONS } from "Styles/Constants";

const { Header } = Layout;

export const HeaderWrapper = styled(Header)`
	background: #fff;
	box-shadow: 6px 0px 10px #ccc;
	display: flex;
	position: fixed;
	align-items: center;
	justify-content: space-between;
	height: ${DIMENSIONS.HEADER}px;
	line-height: ${DIMENSIONS.HEADER}px;
	overflow: hidden;
	padding: 0 24px;
	width: calc(100% - ${DIMENSIONS.SIDEBAR.FULL}px);
	z-index: 1;

	.actions {
		display: flex;
		align-items: center;
		.avatar {
			width: 35px;
			height: 35px;
			border-radius: 50px;
			margin-right: 6px;
			object-fit: cover;
			flex-shrink: 0;
		}
		.text {
			margin: 0px 8px 0px 5px;
			font-size: 15px;
			font-weight: 600;
			white-space: nowrap;
		}
		.icon {
			cursor: pointer;
			font-size: 18px;
		}
	}
`;
